import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer id="footer" className="relative py-16 px-6 border-t border-muted/30">
      <div className="absolute inset-0 bg-gradient-to-t from-background/50 to-transparent" />
      
      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-12">
          {/* Logo and Tagline */}
          <div className="text-center md:text-left mb-8 md:mb-0">
            <div className="flex items-center justify-center md:justify-start space-x-3 mb-4">
              <Image
                src="/brand/depthme-icon-192.png"
                alt="DepthMe luminous sphere logo - AI-powered journaling for mindfulness and emotional wellness"
                className="w-12 h-12 object-contain"
              />
              <span className="text-2xl font-bold text-gradient">DepthMe</span>
            </div>
          </div>

          {/* Footer Links */}
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link
              to="/privacy"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <a
              href="mailto:hello@depthme.app"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-muted/30 mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between text-sm text-muted-foreground">
          {/* Copyright */}
          <p className="mb-4 md:mb-0">
            © {currentYear} DepthMe. All rights reserved.
          </p>

          {/* Mission Statement */}
          <p className="flex items-center space-x-2">
            <span>Made with</span>
            <Icon name="Heart" size={16} className="text-error" />
            <span>for your inner journey.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;